import Select from "react-select";
import React from "react";
import styles from "../../../pages/blog/parts/styles";

export const CustomSelectExchanges = ({
                                          width,
                                          exchangeOptions,
                                          type,
                                          selectedExchange,
                                          setSelectedExchange,
                                          isMobile,
                                          height,
                                          placeholder = 'Binance, Bybit, Coinbase, Gate, HTX, Mex',
                                          bg = '#23262F'
                                      }) => {
    const customStyles = {
        dropdownIndicator: (base) => ({
            ...base,
            svg: {
                fill: '#777E90',
                width: '16px', // change width
                height: '16px', // optional: adjust height too
            },
        }),
        control: (styles) => ({
            ...styles,
            backgroundColor: bg,
            border: 'none',
            borderRadius: '12px',
            color: "#fff",
            height: isMobile ? '40px' : '40px',
            width: '100%',
            zIndex: '11111',
            boxShadow: 'none',
            fontSize: '18px',
            '&:hover': {
                outline: 'none'
            }
        }),
        input: (styles) => ({
            ...styles,
            color: '#fff',
        }),
        option: (styles, {isSelected, isFocused}) => ({
            ...styles,
            backgroundColor: isSelected
                ? "#6200ea"
                : isFocused
                    ? "#3a3a4b"
                    : "#1e1e2f",
            color: "#fff",
            cursor: "pointer",
            display: "flex",
            fontSize: '18px',
            width: '100%',
            zIndex: '11111',
            alignItems: "center",

        }),
        placeholder: (styles) => ({
            ...styles,
            fontSize: '14px',// Change the font size here
        }),
        menu: (styles) => ({
            ...styles,
            marginTop: '8px',
            borderRadius: '8px',
            backgroundColor: bg,
        }),
        menuList: (styles) => ({
            ...styles,
            borderRadius: '8px',
            backgroundColor: "#171923",
            boxShadow: "0px -4px 20px 1px #6F41D280 inset !important",
            height: '208px',
            padding: "0",
            '&::-webkit-scrollbar': {
                width: '0'
            }
        }),
    };
    return (
        <Select
            width={width}
            color={'neutral.600'}
            isMulti={true}
            className="select-container"
            value={selectedExchange}
            options={exchangeOptions}
            onChange={setSelectedExchange}
            placeholder={placeholder}
            components={{
                IndicatorSeparator: () => null,
            }}
            zIndex={'111111'}
            formatOptionLabel={(e, {context}) => (
                <option>
                    {e.value}
                </option>
            )}
            styles={customStyles}
        />
    );
};
